export default __webpack_public_path__ + "static/media/DataTable.c50ec3cf.svg";